// TypeSet — какой набор типов карточек рекомендуется пресетом. Определяет
// фильтр шаблонов при seeding. Зеркало TYPE_SETS в server/src/routes/launches.ts
// — при правке одного синхронизировать оба.
export type TypeSetKey = "full" | "email" | "content" | "empty";

export interface TypeSetOption {
  key: TypeSetKey;
  label: string;
  types: Array<{ id: string; name: string; color: string; bg: string; text: string }>;
}

export const TYPE_SETS: TypeSetOption[] = [
  {
    key: "full",
    label: "Полный (email + анонс + заметка + лендинг)",
    types: [
      { id: "t_email", name: "Письмо", color: "#14B8A6", bg: "#CCFBF1", text: "#0D6B63" },
      { id: "t_announce", name: "Анонс", color: "#8B5CF6", bg: "#EDE4FE", text: "#5B3BA8" },
      { id: "t_note", name: "Заметка", color: "#F59E0B", bg: "#FEF3C7", text: "#92540C" },
      { id: "t_landing", name: "Лендинг", color: "#EC4899", bg: "#FCE7F3", text: "#9D1D5C" },
    ],
  },
  {
    key: "email",
    label: "Только email / бот",
    types: [
      { id: "t_email", name: "Письмо", color: "#14B8A6", bg: "#CCFBF1", text: "#0D6B63" },
      { id: "t_note", name: "Заметка", color: "#F59E0B", bg: "#FEF3C7", text: "#92540C" },
    ],
  },
  {
    key: "content",
    label: "Контентный (анонсы + сторис + заметки)",
    types: [
      { id: "t_announce", name: "Анонс", color: "#8B5CF6", bg: "#EDE4FE", text: "#5B3BA8" },
      { id: "t_stories", name: "Сторис", color: "#EC4899", bg: "#FCE7F3", text: "#9D1D5C" },
      { id: "t_note", name: "Заметка", color: "#F59E0B", bg: "#FEF3C7", text: "#92540C" },
    ],
  },
  {
    key: "empty",
    label: "Пустой — добавлю типы сам",
    types: [],
  },
];

export function buildDays(
  warmupDays: number,
  broadcastDays: number,
  followupDays: number,
): Array<{ stage: "warmup" | "sales" | "close" }> {
  const days: Array<{ stage: "warmup" | "sales" | "close" }> = [];
  for (let i = 0; i < warmupDays; i++) days.push({ stage: "warmup" });
  for (let i = 0; i < broadcastDays; i++) days.push({ stage: "sales" });
  for (let i = 0; i < followupDays; i++) days.push({ stage: "close" });
  return days;
}

export function pluralDays(n: number): string {
  if (n === 1) return "день";
  if (n >= 2 && n <= 4) return "дня";
  return "дней";
}
